import { AxiosError } from 'axios';

/** Shape of a Laravel validation/error response. */
interface LaravelErrorBody {
  message?: string;
  errors?: Record<string, string[]>;
}

/** A normalized, UI-friendly error extracted from any failed request. */
export interface NormalizedApiError {
  status: number | null;
  message: string;
  /** Field-level validation errors, if the backend returned any. */
  fieldErrors?: Record<string, string>;
}

/**
 * Turn an unknown thrown value into a predictable error object the UI can read.
 * Prefers the backend `message`, falls back to a generic localizable key.
 */
export function normalizeApiError(error: unknown): NormalizedApiError {
  if (error instanceof AxiosError) {
    const body = error.response?.data as LaravelErrorBody | undefined;
    const fieldErrors = body?.errors
      ? Object.fromEntries(
          Object.entries(body.errors).map(([key, msgs]) => [key, msgs[0] ?? '']),
        )
      : undefined;

    return {
      status: error.response?.status ?? null,
      message: body?.message ?? error.message ?? 'errors.network',
      fieldErrors,
    };
  }

  if (error instanceof Error) {
    return { status: null, message: error.message };
  }

  return { status: null, message: 'errors.unknown' };
}
